import React from "react";
import {scrollToId} from "./Utils";
import t from "./I18N/TranslateHelpers";

interface ComponentProps {
  allPages: number[],
  setCurrentPage: any,
  currentPage: number,
  topPageId: string
  numberOfPages: number
}

const Pagination: React.FC<ComponentProps> = ({allPages, setCurrentPage, currentPage, topPageId, numberOfPages}: ComponentProps) => {

  return(
    <footer className="d-flex mt-4 mb-5">
      <nav className="ms-3">
        <ul className="pagination">
          <li>
            <button className="btn btn-light mr-2" onClick={() => [setCurrentPage(currentPage-1), scrollToId(topPageId)]} disabled={currentPage === 1}>
              {t('previous')}
            </button>
          </li>
          {
            allPages.map((index: any) =>
              <li className={ currentPage === index? "page-item active" : "page-item"} key={index}>
                <button className="page-link" onClick={() => setCurrentPage(index)}>{ index }</button>
              </li>
            )
          }
          <li>
            <button className="btn btn-light ml-2" onClick={() => [setCurrentPage(currentPage+1), scrollToId(topPageId)]} disabled={numberOfPages === currentPage}>
              {t('next')}
            </button>
          </li>
        </ul>
      </nav>
    </footer>
  )
}

export default Pagination;
